<script lang="ts">
	import type { DatasheetSideBarPoiData, DateRange, GetYourGuideTour } from '$lib/components/pois/types';
	import type { ClassValue } from 'svelte/elements';
	import SideBarAd from '$lib/components/advertising/SideBarAd.svelte';
	import AccommodationAvailability from '$lib/components/pois/datasheet/accommodation-availability/AccommodationAvailability.svelte';
	import GetYourGuideRecommendations from '$lib/components/pois/datasheet/recommandations/GetYourGuideRecommendations.svelte';

	interface Props {
		poi: DatasheetSideBarPoiData;
		class?: ClassValue;
		onSelectDates?: (datesRange: DateRange) => void;
		onClearDates?: () => void;
		onBookClick?: (getYourGuideTour: GetYourGuideTour) => void;
	}

	const {
		poi,
		class: classes,
		onSelectDates,
		onClearDates,
		onBookClick,
	}: Props = $props();
</script>

<div class={['flex flex-col items-start gap-4', classes]}>
	{#if poi.__typename === 'AccommodationPOI'}
		<AccommodationAvailability datasheetId={poi.datasheetId ?? undefined} {poi} onSelectDates={onSelectDates} onClearDates={onClearDates} />
	{:else if poi.__typename === 'TourismPOI'}
		<GetYourGuideRecommendations coordinates={poi.coordinates} onBookClick={onBookClick} />
	{/if}
	{#if poi.__typename !== 'AccommodationPOI'}
		<SideBarAd />
	{/if}
</div>
